import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  FormGroup,
  FormControlLabel,
  Checkbox,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { filterElements, regionToStates } from "./Utils/filterElements";

const FilterPop = ({
  open,
  filterType,
  onClose,
  onSave,
  selectedValues = [],
}) => {
  const [selected, setSelected] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [autoSelectedStates, setAutoSelectedStates] = useState([]);

  useEffect(() => {
    setSelected(selectedValues);

    // Reset auto-selected states when filter type changes
    if (filterType !== "region") {
      setAutoSelectedStates([]);
    }
  }, [filterType, selectedValues]);

  const handleToggle = (value) => {
    setSelected((prev) => {
      if (prev.includes(value)) {
        // If deselecting a region, remove its states from autoSelectedStates
        if (filterType === "region" && regionToStates[value]) {
          setAutoSelectedStates((current) =>
            current.filter((state) => !regionToStates[value].includes(state))
          );
        }
        return prev.filter((item) => item !== value);
      } else {
        // If selecting a region, add its states to autoSelectedStates
        if (filterType === "region" && regionToStates[value]) {
          setAutoSelectedStates((current) => [
            ...new Set([...current, ...regionToStates[value]]),
          ]);
        }
        return [...prev, value];
      }
    });
  };

  const handleSave = () => {
    onSave(filterType, selected);

    // If saving region selections, also save the auto-selected states
    if (filterType === "region" && autoSelectedStates.length > 0) {
      onSave("state", [
        ...new Set([
          ...selectedValues.filter((val) => filterElements.state.includes(val)),
          ...autoSelectedStates,
        ]),
      ]);
    }

    onClose();
  };

  const handleSelectAll = () => {
    setSelected(
      selected.length === filterElements[filterType].length
        ? []
        : filterElements[filterType]
    );
  };

  const filteredItems =
    filterType === "state"
      ? filterElements[filterType].filter((state) =>
          state.toLowerCase().includes(searchTerm.toLowerCase())
        )
      : filterElements[filterType];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="filter-gallery-popup"
      PaperProps={{
        className: "filter-gallery-paper",
      }}
      aria-labelledby="filter-dialog-title"
      keepMounted={false}
      disablePortal={false}
      disableEnforceFocus={false}
      disableAutoFocus={false}
    >
      <DialogTitle className="filter-gallery-title" id="filter-dialog-title">
        <span>{`Filter by ${filterType}`}</span>
        <Button
          onClick={handleSelectAll}
          sx={{ color: "#81b2ff" }}
          className="filter-gallery-select-all"
        >
          {selected.length === filterElements[filterType]?.length
            ? "Deselect All"
            : "Select All"}
        </Button>
      </DialogTitle>
      <DialogContent>
        {filterType === "state" && (
          <div className="filter-state-search-container">
            <input
              type="text"
              placeholder="Search states..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="filter-state-search-input"
              aria-label="Search states"
            />
          </div>
        )}
        <FormGroup className="filter-gallery-options">
          {filteredItems?.map((item) => (
            <FormControlLabel
              key={item}
              control={
                <Checkbox
                  checked={selected.includes(item)}
                  onChange={() => handleToggle(item)}
                />
              }
              label={item}
            />
          ))}
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button sx={{ color: "#fff" }} onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilterPop;
